module.exports = (__parcel__import__("3wUpi")).then(() => parcelRequire('4MKVl'));